import { FC } from 'react'
import styled, { css } from 'styled-components'

const Container = styled.div<{ isSelected: boolean }>`
  ${({ isSelected, theme }) =>
    isSelected
      ? css`
          background-image: url(/img/icons/check.svg);
          background-color: ${({ theme }) => theme.colors.brandPrimary};
        `
      : 'background-color: rgba(0, 0, 0, 0.3)'};

  background-size: 12px 12px;
  background-repeat: no-repeat;
  background-position: center;

  border: ${({ isSelected }) =>
    isSelected ? 'none' : '1px solid rgba(255, 255, 255, 0.3)'};
  border-radius: 4px;
  width: 24px;
  height: 24px;
  margin-right: 12px;
  transition: 0s;
`

interface Props {
  isSelected: boolean
}

const CustomCheckbox: FC<Props> = ({ isSelected }) => {
  return <Container className="custom-checkbox" isSelected={isSelected} />
}

export default CustomCheckbox
